<div class="announcement-item-header">
  <app-list-item-header [item]="item"></app-list-item-header>
</div>

<hr />

<div class="announcement-item-content" (click)="selectItem.emit(item.urlFragment)">
  <div class="item-title" [style.direction]="item.translation.direction">{{ item.title }}</div>
  <app-hub-item-message [style.direction]="item.translation.direction" [content]="item.message"></app-hub-item-message>

  @if (item.attachments) {
    <app-attachments
      [attachments]="item.attachments"
      (openAttachment)="openAttachment.emit($event)"
      (getThumb)="getThumb.emit($event)">
    </app-attachments>
  }
</div>

<hr />

<div class="announcement-item-author">
  <app-announcement-publisher
    [item]="item"
    [showPublisherLink]="showPublisherLink"
  (selectStudent)="selectStudent.emit($event)"></app-announcement-publisher>
</div>

<hr />
